// ========== icone di default

export abstract class ENUM_ICON_COLOR {
  public static DEFAULT_COLOR = {
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_allegati = {
    FA: '<i class="fas fa-paperclip"></i>',
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_square = {
    FA: '<i class="fas fa-square"></i>',
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_circle = {
    FA: '<i class="fas fa-circle"></i>',
    HEX: '#6d6da5',
  };
  public static DEFAULT_fa_exclamation_circle = {
    FA: '<i class="far fa-exclamation-circle"></i>',
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_map_marker = {
    FA: '<i class="far fa-map-marker-check"></i>',
    HEX: '#6d6da5',
  };
  public static DEFAULT_fa_user_friends = {
    FA: '<i class="fas fa-user-friends"></i>',
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_bomb = {
    FA: '<i class="fas fa-bomb"></i>',
    HEX: '#6d6da5',
  };

  public static DEFAULT_fa_arrows = {
    FA: '<i class="fas fa-exchange"></i>',
    HEX: '#6d6da5',
  };
}
